import { CoreError } from '@goodt-wcore/errors';
import { DomainError } from './DomainError';

export class ModelError extends DomainError {
    _errors = [];

    /**
     * @param {ValidationErrors[]} errors
     */
    static createFromErrors(errors) {
        return new this(undefined, errors);
    }

    constructor(message = 'Model error', errors = []) {
        super(message);
        this.name = 'ModelError';
        this._errors = errors;
    }

    get errors() {
        return this._errors;
    }

    getError(condition) {
        if (condition == null) {
            throw new CoreError('condition argument required');
        }
        return this._errors.find(({ data }) => Object.entries(condition).every(([key, value]) => data[key] === value));
    }

    hasError(condition) {
        return this._errors.some(({ data }) => Object.entries(condition).every(([key, value]) => data[key] === value));
    }

    isValid(condition) {
        return !this.hasError(condition);
    }

    [Symbol.iterator]() {
        return this._errors.values();
    }
}
